import { c as _c } from "react/compiler-runtime";
import { displayPercentageDiscount } from "@website/accommodation-ui/helpers/calculatePercentageDiscount";
import SnappPayLogo from "@website/accommodation-ui/hotel-reserve-booking-card/assets/snapp_pay_logo.png";
import { HotelReserveBookingCardType } from "@website/accommodation-ui/hotel-reserve-booking-card/hotel-reserve-booking-card.type";
import { useJwtToken } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { CounterButton } from "@website/ui/counter-button";
import { Datepicker } from "@website/ui/datepicker";
import { InfoChips } from "@website/ui/info-chips";
import { LazyImage } from "@website/ui/lazy-image";
import { MiniChips } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { useLoginModal } from "@website/widget/login";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelReserveBookingCardDetail: FC<HotelReserveBookingCardType> = properties => {
  const $ = _c(92);
  const {
    phoneNumber
  } = useJwtToken();
  const {
    isLoading,
    extraCapacity: t0,
    nightCount,
    capacity: t1,
    passengersCount: t2,
    price,
    minStay,
    priceOfExtraPassengers,
    discount,
    total_price,
    total_price_off,
    calendarDate,
    increaseDisabled,
    decreaseDisabled,
    submitDisabled,
    submitDisabledMessage,
    reviewRate,
    disableLimit,
    onChangeDatePicker,
    onCalendarAccept,
    createBook,
    onChangePassengersCount,
    showMinStayAlarm,
    calendarData,
    disableDates,
    basePrice,
    snappPayData,
    cancellationRuleHintText,
    datePickerIsOpenAtInit
  } = properties;
  const extraCapacity = t0 === undefined ? 0 : t0;
  const capacity = t1 === undefined ? 0 : t1;
  const passengersCount = t2 === undefined ? 0 : t2;
  const {
    onLoginModalOpen
  } = useLoginModal();
  const router = useRouter();
  const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
  const hasSelectedDateRange = Boolean(router?.query?.date_from && router?.query?.date_to);
  const isMinimumStayViolated = Boolean(hasSelectedDateRange && minStay && Number(nightCount) < Number(minStay));
  const openDatePicker = _temp;
  let t3;
  if ($[0] !== createBook || $[1] !== onLoginModalOpen || $[2] !== phoneNumber || $[3] !== router.query.date_from || $[4] !== router.query.date_to) {
    t3 = () => {
      if (!router?.query?.date_from || !router?.query?.date_to) {
        openDatePicker();
      }
      if (!phoneNumber && router?.query?.date_from && router?.query?.date_to) {
        return onLoginModalOpen().then(() => createBook?.());
      }
      if (router?.query?.date_from && router?.query?.date_to) {
        createBook?.();
      }
    };
    $[0] = createBook;
    $[1] = onLoginModalOpen;
    $[2] = phoneNumber;
    $[3] = router.query.date_from;
    $[4] = router.query.date_to;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const submitOnClick = t3;
  let t4;
  if ($[6] !== reviewRate || $[7] !== submitDisabled) {
    t4 = !submitDisabled && <div className="mb-6 flex w-full flex-row items-center justify-between">{reviewRate ? <MiniChips StartIcon={<MaterialIcon name="star" />} color="success" text={reviewRate} variant="accent" /> : null}</div>;
    $[6] = reviewRate;
    $[7] = submitDisabled;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = calendarDate?.length < 2;
  const t6 = calendarDate?.length < 2 ? "\u0644\u0637\u0641\u0627 \u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F \u0648 \u062E\u0631\u0648\u062C \u062E\u0648\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0645\u0627\u06CC\u06CC\u062F." : "";
  let t7;
  if ($[9] !== calendarData || $[10] !== calendarDate || $[11] !== datePickerIsOpenAtInit || $[12] !== disableDates || $[13] !== disableLimit || $[14] !== onCalendarAccept || $[15] !== onChangeDatePicker || $[16] !== t5 || $[17] !== t6) {
    t7 = <Datepicker acceptEmpty={true} calendarData={calendarData} disableDates={disableDates} disableLimit={disableLimit} error={t5} fromTitle={"\u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F"} fullWidth={true} helperText={t6} mode="range" onChange={onChangeDatePicker} ctaAcceptClick={onCalendarAccept} toTitle={"\u062A\u0627\u0631\u06CC\u062E \u062E\u0631\u0648\u062C"} value={calendarDate} initialOpen={datePickerIsOpenAtInit} />;
    $[9] = calendarData;
    $[10] = calendarDate;
    $[11] = datePickerIsOpenAtInit;
    $[12] = disableDates;
    $[13] = disableLimit;
    $[14] = onCalendarAccept;
    $[15] = onChangeDatePicker;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="text-subtitle-1 text-on-surface-high-emphasis">تعداد مسافر</div>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== router.locale || $[21] !== router.query.extra_capacity || $[22] !== router.query.room_capacity) {
    t9 = Number(router?.query?.room_capacity || 0) > 0 && `${numberConvert(Number(router?.query?.room_capacity) - Number(router?.query?.extra_capacity || 0), {
      locale: router.locale
    })} نفر پایه`;
    $[20] = router.locale;
    $[21] = router.query.extra_capacity;
    $[22] = router.query.room_capacity;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== router.locale || $[25] !== router.query.extra_capacity) {
    t10 = Number(router?.query?.extra_capacity || 0) > 0 && ` + ${numberConvert(router?.query?.extra_capacity, {
      locale: router.locale
    })} نفر اضافه`;
    $[24] = router.locale;
    $[25] = router.query.extra_capacity;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <div className="flex flex-col">{t8}<span className="text-body-2 text-on-surface-medium-emphasis mt-1 lg:hidden">{t9}{t10}</span></div>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== decreaseDisabled || $[31] !== increaseDisabled || $[32] !== onChangePassengersCount || $[33] !== passengersCount || $[34] !== router.locale) {
    t12 = <CounterButton color="secondary" decreaseDisabled={decreaseDisabled} increaseDisabled={increaseDisabled} locale={router.locale} onChange={onChangePassengersCount} value={passengersCount} variant="outline" />;
    $[30] = decreaseDisabled;
    $[31] = increaseDisabled;
    $[32] = onChangePassengersCount;
    $[33] = passengersCount;
    $[34] = router.locale;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t11 || $[37] !== t12) {
    t13 = <div className="mt-4 flex items-center justify-between">{t11}{t12}</div>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== router.query.room_capacity) {
    t14 = Number(router.query.room_capacity || 0) === 0 && <p className="text-error text-caption">تعداد مسافران را انتخاب کنید.</p>;
    $[39] = router.query.room_capacity;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t13 || $[42] !== t14 || $[43] !== t4 || $[44] !== t7) {
    t15 = <div>{t4}{t7}{t13}{t14}</div>;
    $[41] = t13;
    $[42] = t14;
    $[43] = t4;
    $[44] = t7;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== basePrice || $[47] !== cancellationRuleHintText || $[48] !== capacity || $[49] !== discount || $[50] !== extraCapacity || $[51] !== nightCount || $[52] !== passengersCount || $[53] !== price || $[54] !== priceOfExtraPassengers || $[55] !== router.locale || $[56] !== router.query.date_from || $[57] !== router.query.date_to || $[58] !== router.query.room_capacity || $[59] !== submitDisabled || $[60] !== submitDisabledMessage || $[61] !== total_price || $[62] !== total_price_off) {
    t16 = !submitDisabled && <><div className="my-6">{router?.query?.date_from && router?.query?.date_to && passengersCount > 0 && <div className="mb-4 flex items-center justify-between"><div className="text-body-2 text-on-surface-medium-emphasis">{!submitDisabledMessage && `${numberConvert(nightCount, {
              locale: router.locale
            })} شب برای ${numberConvert(passengersCount > capacity ? capacity : passengersCount, {
              locale: router.locale
            })} نفر`}</div><span className="border-outline-thin mx-1 flex-1 border-t border-dashed" /><div className="text-on-surface-medium-emphasis text-body-2">{`${numberConvert(numberSeparator(isVilla ? (total_price ?? 0) - (priceOfExtraPassengers ?? 0) : price), {
              locale: router.locale
            })} تومان`}</div></div>}{(!router?.query?.date_from || !router?.query?.date_to || Number(router.query.room_capacity || 0) <= 0) && <div className="flex items-center justify-between"><div className="text-subtitle-2 text-on-surface-high-emphasis">قیمت از شبی</div><span className="border-outline-thin mx-1 flex-1 border-t border-dashed" /><div className="text-on-surface-high-emphasis text-body-2">{`${numberConvert(numberSeparator(basePrice), {
              locale: router.locale
            })} تومان`}</div></div>}{extraCapacity ? <div className="mb-4 flex items-center justify-between"><div className="text-body-2 text-on-surface-medium-emphasis">{`${numberConvert(extraCapacity, {
              locale: router.locale
            })} نفر اضافه`}</div><span className="border-outline-thin mx-1 flex-1 border-t border-dashed" /><div className="text-on-surface-medium-emphasis text-body-2">{priceOfExtraPassengers !== 0 && `${numberConvert(numberSeparator(priceOfExtraPassengers), {
              locale: router.locale
            })} تومان`}</div></div> : null}{discount ? <div className="mb-4 flex items-center justify-between"><div className={`text-body-2 ${isVilla ? "!text-success" : "text-on-surface-medium-emphasis"}`}>تخفیف</div><span className="border-outline-thin mx-1 flex-1 border-t border-dashed" /><div className={`${isVilla ? "!text-success" : "text-on-surface-medium-emphasis"} text-body-2`}>{`${numberConvert(numberSeparator(discount), {
              locale: router.locale
            })} تومان`}</div></div> : null}</div>{router?.query?.date_from && router?.query?.date_to && Number(router.query.room_capacity || 0) > 0 && <><div className="bg-outline-thin h-px w-full" />{cancellationRuleHintText && <p className="text-primary-inverse flex pt-4 text-xs"><MaterialIcon name="info" variant="outlined" /><span className="pr-2">{cancellationRuleHintText}</span></p>}<div className="mt-6 flex items-center justify-between"><div className="text-subtitle-2 text-on-surface-high-emphasis">جمع مبلغ قابل پرداخت</div><span className="border-outline-thin mx-1 flex-1 border-t border-dashed sm:hidden" /><div className="text-on-surface-high-emphasis text-headline-6">{isVilla && <div className="flex w-full items-center justify-end gap-2">{total_price !== total_price_off && <><span className="text-on-surface-disable text-body-2 line-through">{numberConvert(numberSeparator(total_price), {
                    locale: router.locale || "fa"
                  })}</span><InfoChips className="!w-[30px] justify-center !p-[2px]" size="medium" text={displayPercentageDiscount(total_price as number, total_price_off as number)} variant="round-accent" /></>}</div>}{`${numberConvert(numberSeparator(total_price_off), {
              locale: router.locale
            })} تومان`}</div></div></>}</>;
    $[46] = basePrice;
    $[47] = cancellationRuleHintText;
    $[48] = capacity;
    $[49] = discount;
    $[50] = extraCapacity;
    $[51] = nightCount;
    $[52] = passengersCount;
    $[53] = price;
    $[54] = priceOfExtraPassengers;
    $[55] = router.locale;
    $[56] = router.query.date_from;
    $[57] = router.query.date_to;
    $[58] = router.query.room_capacity;
    $[59] = submitDisabled;
    $[60] = submitDisabledMessage;
    $[61] = total_price;
    $[62] = total_price_off;
    $[63] = t16;
  } else {
    t16 = $[63];
  }
  const t17 = `flex flex-col gap-2 ${router?.query?.date_from && router?.query?.date_to ? "py-6" : "pb-6 pt-0"}`;
  const t18 = Boolean(!isLoading && submitDisabled && calendarDate?.length === 2 || Number(router.query.room_capacity || 0) === 0 && router?.query?.date_from && router?.query?.date_to || isMinimumStayViolated);
  const t19 = router?.query?.date_from && router?.query?.date_to ? "\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0631\u0632\u0631\u0648" : "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E";
  let t20;
  if ($[64] !== isLoading || $[65] !== submitOnClick || $[66] !== t18 || $[67] !== t19) {
    t20 = <Button disabled={t18} fullWidth={true} loading={isLoading} onClick={submitOnClick} size="large">{" "}{t19}</Button>;
    $[64] = isLoading;
    $[65] = submitOnClick;
    $[66] = t18;
    $[67] = t19;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  let t21;
  if ($[69] !== isMinimumStayViolated || $[70] !== minStay || $[71] !== router.locale || $[72] !== showMinStayAlarm) {
    t21 = showMinStayAlarm && isMinimumStayViolated ? <div className="text-error text-caption pt-4">{`حداقل ${numberConvert(minStay, {
        locale: router.locale
      })} شب اقامت`}</div> : null;
    $[69] = isMinimumStayViolated;
    $[70] = minStay;
    $[71] = router.locale;
    $[72] = showMinStayAlarm;
    $[73] = t21;
  } else {
    t21 = $[73];
  }
  let t22;
  if ($[74] !== isLoading || $[75] !== submitDisabledMessage) {
    t22 = submitDisabledMessage && !isLoading && <p className="text-error text-caption">{submitDisabledMessage}</p>;
    $[74] = isLoading;
    $[75] = submitDisabledMessage;
    $[76] = t22;
  } else {
    t22 = $[76];
  }
  let t23;
  if ($[77] !== snappPayData?.isEligible || $[78] !== snappPayData?.showDownPayment) {
    t23 = snappPayData?.isEligible && snappPayData?.showDownPayment && <><div className="hidden flex-row items-center gap-1 self-center px-6 pb-2 pt-6 lg:flex"><LazyImage src={SnappPayLogo?.src} width={20} height={20} /><span className="text-body-2 text-on-surface-medium-emphasis">امکان پرداخت قسطی با اسنپ‌‌پی</span></div></>;
    $[77] = snappPayData?.isEligible;
    $[78] = snappPayData?.showDownPayment;
    $[79] = t23;
  } else {
    t23 = $[79];
  }
  let t24;
  if ($[80] !== t17 || $[81] !== t20 || $[82] !== t21 || $[83] !== t22 || $[84] !== t23) {
    t24 = <div className={t17}>{t20}{t21}{t22}{t23}</div>;
    $[80] = t17;
    $[81] = t20;
    $[82] = t21;
    $[83] = t22;
    $[84] = t23;
    $[85] = t24;
  } else {
    t24 = $[85];
  }
  let t25;
  if ($[86] !== t16 || $[87] !== t24) {
    t25 = <div>{t16}{t24}</div>;
    $[86] = t16;
    $[87] = t24;
    $[88] = t25;
  } else {
    t25 = $[88];
  }
  let t26;
  if ($[89] !== t15 || $[90] !== t25) {
    t26 = <div className="flex h-full flex-col justify-between px-6 pt-6">{t15}{t25}</div>;
    $[89] = t15;
    $[90] = t25;
    $[91] = t26;
  } else {
    t26 = $[91];
  }
  return t26;
};
function _temp() {
  const datePickerStartInput = document.querySelector("[data-testid=\"date_picker_start_input\"]");
  datePickerStartInput?.scrollIntoView({
    block: "center"
  });
  datePickerStartInput?.click();
}